import './video-player.scss'

import Plyr from 'plyr'

import controls from './player-controls'
import bodyScroll from '../../../src/js/utils/body-scroll'
import overlay from '../../../src/js/utils/overlay'

const selectors = {
  player: '#player',
  container: '.video__content',
  play: '[data-video-button-play]',
  close: '[data-player-button-close]',
  duration: '[data-player-duration]',
}

const elements = {
  player: null,
  play: null,
  close: null,
  duration: null,
}

const classes = {
  show: 'video_show',
  hideControl: 'hide-controls',
  playing: 'playing',
}

function init() {
  elements.player = document.querySelector(selectors.player)

  if (!elements.player) return null
  elements.play = document.querySelector(selectors.play)
  elements.close = document.querySelector(selectors.close)

  const videoContainer = document.querySelector(selectors.container)
  const video = new Plyr(elements.player, {
    controls,
  })
  const isSingleVideo = elements.player.dataset.type === 'video'

  function changeView(isValue) {
    videoContainer.classList[isValue](classes.playing)
  }

  video.on('playing', () => {
    if (isSingleVideo) return

    changeView('add')
    bodyScroll().disabledScroll()
    overlay().showOverlay()
  })

  video.on('exitfullscreen', () => {})

  elements.close.addEventListener('click', () => {
    video.pause()
    video.stop()
    overlay().hideOverlay()
    bodyScroll().enabledScroll()
    changeView('remove')
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init()
  },
  { once: true }
)
